import React from "react";
import ReactDOM from "react-dom";

const devToolsRoot = document.getElementById("dev-tools-root");

class DevTools extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement("div");
    }

    componentDidMount() {
        if (this.el && devToolsRoot) {
            this.el.style.minHeight = "7vh";
            devToolsRoot.appendChild(this.el);
        }
    }

    componentWillUnmount() {
        // Remove the element from the DOM when we unmount
        if (this.el && devToolsRoot) {
            devToolsRoot.removeChild(this.el);
        }
    }

    render() {
        // Use a portal to render the children into the element
        return ReactDOM.createPortal(
            // Any valid React child: JSX, strings, arrays, etc.
            this.props.children,
            // A DOM element
            this.el
        );
    }
}
export default DevTools;